import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'src/app/services/global.service';

import { NewCustomerComponent } from '../new-customer/new-customer.component';
import { ClienteService } from 'src/app/services/cliente.service';
import { ArgumentType } from '@angular/compiler/src/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { __importDefault } from 'tslib';

@Component({
  selector: 'app-cliente',
  templateUrl: './cliente.component.html',
  styleUrls: ['./cliente.component.css']

})

export class ClienteComponent implements OnInit {
  // Number
  prof: number;
  i: number = 0;

  //array
  profile: Array<any> = []
  user: Array<any> = [];
  selectedUser: Array<any> = [];
  response: Array<any> = [];
  tempArray: Array<any> = [];
  backupArray: Array<any> = [];

  //boolean
  test: boolean;
  customerUser: boolean = true;
  choose: boolean;
  responseBoolen: boolean = false;

  //string
  token: string;

  //Input
  @Input() customer;
  @Input() folderName;
  @Input() address;

  constructor(
    private clienteService: ClienteService,
    private modalService: NgbModal,
    private globals: GlobalService,
    public activeModal: NgbActiveModal
  ) { }


  ngOnInit() {
    if (!this.token) {
      this.token = this.globals.getToken();
    }
    this.getProfile();
    this.change();
    this.getAllUser();
  }

  getProfile() {
    this.clienteService.getProfile(this.token).subscribe(
      res => {
        this.profile = res;
        let i = 0;

      },
      err => {
        console.error("Errore in getProfile: ", err);

      }
    )
  }

  change() {
    if (this.customer.customer_id) {
      this.responseBoolen = true;
      this.clienteService.getUser(this.token, this.customer.customer_id).subscribe(
        res => {
          // this.response = res;
          this.selectedUser = res;
          this.backupArray = res;
          this.selectedUser.forEach(element => {
            this.tempArray.push({ user_id: element.user_id, profile_id: element.profile_id })
          });
        },
        err => {
          console.error("errore in getUserofCustomer", err);

        }
      )

      if (this.customer.business_name) {
        this.test = true;
      } if (this.customer.last_name) {
        this.test = false;
      }
    } else {
      if (this.customer.business_name) {
        this.test = true;
      } if (this.customer.last_name) {
        this.test = false;
      }
    }
  }



  getAllUser() {
    this.clienteService.getAllUser(this.token).subscribe(
      res => {
        this.user = res;
      },
      err => {
        console.error("Errore in getOperators", err);

      }
    )
  }

  addUser(passUser, profile) {
    let control: boolean = false

    this.selectedUser.forEach(use => {
      if (use.user_id == passUser.user_id) {
        control = true;
      }
    });

    if (control == false) {
      this.i = this.i + 1;
      this.selectedUser.push(passUser);
      this.tempArray.push({ user_id: passUser.user_id, profile_id: profile })
      this.getAllUser();
    } else {
      alert("il profilo selezionato è già stato inserito nella lista")
    }

  }

  newAddUser(passUser, profile) {
    this.i = this.i + 1;
    this.response.push(passUser);
    this.tempArray.push({ user_id: passUser.user_id, profile_id: profile })
    this.getAllUser();
  }


  updateUser(profile) {
    if (this.i >= 1) {
      let obj = {
        associations: this.tempArray,
        profile_id: 1
      }
      this.clienteService.setUser(this.token, obj, this.customer.customer_id).subscribe(
        res => {
        },
        err => {
          console.error("errore nel SetUser");
        }
      )
      this.activeModal.close();
    } else {
      alert("Non hai aggiunto altre utenze.")
    }
  }

  addCustomer(profile) {
    let objcus = {
      customer: this.customer,
      foldername: this.folderName,
      address: this.address
    }
    objcus.address.forEach((addres) => {
      if (addres.residence) {
        addres.residence = 'Y';
      } else {
        addres.residence = 'N';
      }

      if (addres.domicile) {
        addres.domicile = 'Y';
      } else {
        addres.domicile = 'N';
      }

    });
    this.clienteService.addCustomer(this.token, objcus).subscribe(
      res => {
        if (this.i >= 1) {
          let obj = {
            associations: this.tempArray
          }
          this.clienteService.setUser(this.token, obj, res.customer_id).subscribe(
            res => {
            },
            err => {
              console.error("errore nel SetUser");
            }
          )
        }
        this.activeModal.close();
      },
      err => {
        console.error("Errore in addCustomer");
      }
    )
  }

  canceling() {
    if (this.i > 0) {
      this.selectedUser = this.backupArray
    }
    this.activeModal.close('cancel');
  }

  openOtherPopup() {

    const modalRef = this.modalService.open(NewCustomerComponent, { backdrop: 'static', size: 'xl', centered: true, scrollable: true })
    // modalRef.componentInstance.customer = customer;
    modalRef.result.then(result => {
      this.getAllUser();
    }, reason => {
    });
  }

  deleteUtenza(id) {
    this.i = this.i + 1;
    // this.selectedUser.forEach(element, k => {
    //   if(element.user_id == id.user_id){
    //     let save = k
    //   }
    // });
    this.selectedUser.splice(this.selectedUser.indexOf(id), 1)


  }

}
